import { IGetAllWordingsInfo, ICreateWording, TWordingLevel, IUpdateWordings, IGetWordingsCategoriesInfo } from 'types';
import { AxiosResponse } from 'axios';
import { request } from '../index';

const serviceGetAllWordingsInfo = (): Promise<IGetAllWordingsInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/Localizations` });
};

const serviceCreateWording = (data: ICreateWording): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'postWithToken', url: `/api/Localizations`, data });
};

const serviceDeleteWording = (localizationSettingsId: string, level: TWordingLevel): Promise<AxiosResponse<void>> => {
	return request({
		typeOfRequest: 'deleteWithTokenAndWithParameterInUrlLine',
		url: `/api/Localizations/${localizationSettingsId}?level=${level}`,
	});
};

const serviceUpdateWordings = (data: IUpdateWordings): Promise<AxiosResponse<void>> => {
	return request({ typeOfRequest: 'putWithToken', url: `/api/Wordings`, data }); // TODO not implemented on BE
};

const serviceGetWordingCategories = (): Promise<IGetWordingsCategoriesInfo> => {
	return request({ typeOfRequest: 'getWithToken', url: `/api/LocalizationGroups` });
};

export {
	serviceGetAllWordingsInfo,
	serviceCreateWording,
	serviceDeleteWording,
	serviceUpdateWordings,
	serviceGetWordingCategories,
};
